import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export type CorporateCurrency = {
  currency: string;
  percentage: string;
};

type CorporateCurrenciesTableProps = {
  values: CorporateCurrency[];
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
};

const CorporateCurrenciesTable = ({
  values,
  setFieldValue,
}: CorporateCurrenciesTableProps) => {
  const handleAddRow = () => {
    const newRows = [...values, { currency: "", percentage: "" }];
    setFieldValue("corporateCurrencies", newRows);
  };

  const handleChangeRow = (
    index: number,
    field: keyof CorporateCurrency,
    value: string
  ) => {
    const newRows = values.map((row, idx) =>
      idx === index ? { ...row, [field]: value } : row
    );
    setFieldValue("corporateCurrencies", newRows);
  };

  const handleRemoveRow = (index: number) => {
    const newRows = values.filter((_, idx) => idx !== index);
    setFieldValue("corporateCurrencies", newRows);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead
            sx={{
              backgroundColor: "lightblue",
              "& .MuiTableCell-root": { fontWeight: "bold", color: "black" },
            }}
          >
            <TableRow>
              <TableCell>Currency</TableCell>
              <TableCell align="right">%</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {values.map((row, index) => (
              <TableRow key={index}>
                <TableCell>
                  <TextField
                    fullWidth
                    placeholder="Currency"
                    value={row.currency}
                    onChange={(e) =>
                      handleChangeRow(index, "currency", e.target.value)
                    }
                  />
                </TableCell>
                <TableCell align="right">
                  <TextField
                    fullWidth
                    placeholder="%"
                    value={row.percentage}
                    onChange={(e) =>
                      handleChangeRow(index, "percentage", e.target.value)
                    }
                  />
                </TableCell>
                <TableCell align="center">
                  <IconButton onClick={() => handleRemoveRow(index)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button variant="outlined" onClick={handleAddRow} sx={{ mt: 2 }}>
        Add Row
      </Button>
    </>
  );
};

export default CorporateCurrenciesTable;
